import * as React from "react";
import * as ReactDOM from "react-dom";
import * as $ from "jquery";

import {IEditItemCompProps, IEditItemCompState} from "../../interfaces/layout/blocks/IUser";
import { EditItemCompMain } from "./EditItemCompMain";
import Modal from "../lib/components/Modal";

declare var window:any;
window.currentModal = null;

export class EditItemComp extends React.Component<IEditItemCompProps, IEditItemCompState>{
    constructor(props: IEditItemCompProps) {
        super(props);
    }

    render(){
        return(
            <EditItemCompMain registrationMode={this.props.registrationMode} id={ this.props.id } profileMode={this.props.profileMode} closeHandler={this.props.closeHandler} />
        );
    }
}
export default class InitEditItemComp {
    constructor() {
        var div: HTMLDivElement = document.getElementById('item_editor_comp') as HTMLDivElement;
        if (div !== null) {
            var registrationMode:boolean = false;
            if ( div.dataset.registrationmode !== undefined && div.dataset.registrationmode === 'true' ) {
                registrationMode = true;
            }
            var id:number = 0;
            if ( div.dataset.id !== undefined ) {
                id = parseInt(div.dataset.id);
            }
            var profileMode:boolean = false;
            if (div.dataset.profile_mode !== undefined) {
                profileMode = div.dataset.profile_mode==='true'?true:false;
            }
            ReactDOM.unmountComponentAtNode(div);
            ReactDOM.render(< EditItemComp registrationMode={
                registrationMode
            } id={id} profileMode={profileMode}/>, div);

            if ( profileMode === true ) {

            }else{
                if ( registrationMode === true ) {
                    window.currentModal = new Modal($('#item_edit_modal'), 'Regisztráció', '', true);
                    window.currentModal.setCloseHandlerCb(null);
                }else{
                    window.currentModal = new Modal($('#item_edit_modal'), '', '', false);
                    window.currentModal.setCloseHandlerCb(null);
                }
            }

        }
    }
}

export class ReInit {
    constructor(id:number, closeHandler:Function) {
        var div: HTMLDivElement = document.getElementById('item_editor_comp') as HTMLDivElement;
        if (div !== null) {
			// div.innerHTML = '';
            var registrationMode:boolean = false;
            ReactDOM.unmountComponentAtNode(div);
            ReactDOM.render(< EditItemComp registrationMode={
                registrationMode
            } id={ id } closeHandler={ closeHandler } profileMode={false}/>, div);
            window.currentModal.open();
			window.currentModal.setCloseHandlerCb(null);
        }
    }
}



// WEBPACK FOOTER //
// ./components/EditItemComp.tsx